<template>
  <router-view />
</template>

<script>
export default {
  name: "RenderLayout",
};
</script>
